import dataSource from '../DataSources/dataSource';
import dataSourceCollection from '../DataSources/dataSourceCollection';

// (Template, DOMDocument, XPathEngine) -> DataSourceCollection
function createDataSources(template, mainDom, xpathEngine) {
    const sources = template.listDataSources().map(dataSource);
    const mainDataSource = dataSource({ name: '', initialDom: mainDom });

    mainDataSource.reassignIds();

    return dataSourceCollection(sources.concat(mainDataSource), xpathEngine);
}

export default createDataSources;
